import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { usePostHog } from "posthog-js/react";
import Plans from "./plans";
import EmbeddedCheckoutComponent from "./EmbeddedCheckout";

const SelectPlan = () => {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const savedPlanId = localStorage.getItem("selectedPlan");
  const defaultPlan = savedPlanId || "particular-destacado";
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCheckout, setShowCheckout] = useState(true);

  useEffect(() => {
    if (posthog) {
      posthog.capture("Signup - Particular", {
        step: 5,
        stepName: "plan_selected",
        plan: defaultPlan,
      });
    }
  }, [posthog, defaultPlan]);

  const OWNER_PLANS = [
    {
      idPlan: "particular-1",
      priceId: import.meta.env.VITE_PUBLIC_INDIVIDUAL || "price_1SnSdaHGBw2VKdDPGG3FKZr5",
    },
    {
      idPlan: "particular-destacado",
      priceId:
        import.meta.env.VITE_PUBLIC_INDIVIDUAL_THREE_MONTHS_FEATURED ||
        "price_1SD8s7HGBw2VKdDP7zDW3lqZ",
    },
    {
      idPlan: "particular-3",
      priceId:
        import.meta.env.VITE_PUBLIC_INDIVIDUAL_THREE_MONTHS || "price_1SD8srHGBw2VKdDPj6z2Q4Dh",
    },
  ];

  const getSelectedPriceId = () => {
    const plan = OWNER_PLANS.find((p) => p.idPlan === selectedPlan);
    return plan ? plan.priceId : null;
  };

  const handleBackToPlans = () => {
    setShowCheckout(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("CYTpropertyUuid")) {
      navigate("/unirse/ubicacion-precio");
    }
  }, [navigate]);

  useEffect(() => {
    if (selectedPlan) {
      localStorage.setItem("selectedPlan", selectedPlan);
      setErrorMessage("");
    }
  }, [selectedPlan]);

  return (
    <div className="sticky bottom-0 col-span-2 w-full bg-white md:p-4 md:pb-10 h-full md:block">
      {showCheckout ? (
        <div className="w-full flex items-center justify-center">
          <EmbeddedCheckoutComponent
            key={selectedPlan}
            priceId={getSelectedPriceId()}
            onBack={handleBackToPlans}
            propertyId={localStorage.getItem("CYTpropertyUuid")}
            checkoutType="property"
          />
        </div>
      ) : (
        <>
          <div className="w-full flex items-center justify-center mb-6">
            <h1 className="text-2xl font-semibold w-full max-w-2xl text-center">
              Elige el plan que mejor se adapte a ti
            </h1>
          </div>

          <Plans
            selectedPlan={selectedPlan}
            onSelectPlan={(id) => {
              setSelectedPlan(id);
              if (posthog && id !== selectedPlan) {
                posthog.capture("Signup - Particular", {
                  step: 5,
                  stepName: "plan_selected",
                  plan: id,
                });
              }
              setShowCheckout(true);
            }}
          />

          {errorMessage && (
            <div className="w-full flex items-center justify-center mt-4">
              <div className="max-w-2xl w-full">
                <div
                  className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative"
                  role="alert"
                >
                  <span className="block sm:inline">{errorMessage}</span>
                </div>
              </div>
            </div>
          )}

          <div className="w-full flex items-center justify-center mt-8 pt-4 border-t border-gray-100">
            <div className="max-w-2xl w-full text-center">
              <a
                href={"/unirse/descripcion"}
                className="text-gray-500 hover:text-black underline transition-colors"
              >
                Regresar al paso anterior
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectPlan;
